export { default as adminController } from './admin.controller';
export { default as baseHomeController } from './base.home.controller';
export { default as chatbotController } from './chatbot.controller';
export { default as crudController } from './crud.controller';
export { default as digitalizationsController } from './digitalizations.controller';
export { default as folderController } from './folder.controller';
export { default as forgotPasswordController } from './forgot.password.controller';
export { default as homeController } from './home.controller';
export { default as linkedDocumentsController } from './linked.documents.controller';
export { default as loginController } from './login.controller';
export { default as pickFolderController } from './pick.folder.controller';
export { default as publicFolderLinkController } from './public.folder.link.controller';
export { default as publicLinkController } from './public.link.controller';
export { default as recoverPasswordController } from './recover.password.controller';
export { default as searchController } from './search.controller';
export { default as sendByEmailController } from './send.by.email.controller';
export { default as sendFilesController } from './send.files.controller';
export { default as supportController } from './support.controller';
export { default as timecheckController } from './timecheck.controller';
export { default as treeController } from './tree.controller';
export { default as userController } from './user.controller';
export { default as viewerController } from './viewer.controller';
